import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  column-gap: 0.5rem;
  width: 100%;

  .save-button {
    flex-grow: 1;
  }
`;
